// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/table-cells.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/outline/table-cells'

import { Icon, type IconComponentProps } from '../icon'

export const TableCellsIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
